import {NodeName} from "../flavour/openlexia/nodeName.mjs";

class Node {

    constructor(name, value, rule, parent) {
        this.isOpen = true
        this.name = name
        this.value = value
        this.originalText = value
        this.rule = rule
        this.children = []
        this.parent = parent
    }

    onEdnOfMarkup() {
        if(!this.rule) return
        this.rule.onEndOfMarkup(this)
    }

    close() {
        this.isOpen = false
        this.rule = null

        // cancel all the children
        this.children.forEach( (child) => child.cancel())

        return this
    }

    cancel() {

        // do not cancel closed nodes
        if(this.isClosed()) return

        // cancel all the children
        this.children.forEach( (child) => child.cancel())

        // treat as plain text and turn children into siblings
        this.name = NodeName.TEXT
        this.value = this.originalText
        this.parent.children.push(...this.children)
        this.isOpen = false
        this.rule = null
        this.children = []

    }

    addChildren(children) {
        this.children.push(...children)
        return this
    }

    isClosed() {
        return !this.isOpen
    }
}

export {Node}